import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	AlertComponent,
	BadgeComponent,
	CardSelectComponent,
	DividerComponent,
	FormGroupComponent,
	IconComponent,
	InfoGroupComponent,
	InputComponent,
	InputQuantityComponent,
	ItemComponent,
	ListDetailComponent,
	RateStatusComponent,
	SelectComponent,
	SwitchComponent,
	TileComponent,
	ToggleComponent,
	TooltipComponent,
} from '@tecalisdev/infinity';
import {
	CONFIDENCE_THRESHOLD,
	DEMAND_LEVEL,
	IPolDemandLevel,
} from '../../../models/workflows.models';
import { OPERATION_TYPE, POL_TEST, POL_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de POL en el editor (NIF-530).
 * Abrir cuando: modo, demand level, tests o fraud_scoring facial.
 */
@Component({
	selector: 'app-workflow-form-pol-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		FormGroupComponent,
		CardSelectComponent,
		ToggleComponent,
		SelectComponent,
		InputComponent,
		InputQuantityComponent,
		ListDetailComponent,
		SwitchComponent,
		DividerComponent,
		InfoGroupComponent,
		IconComponent,
		BadgeComponent,
		AlertComponent,
		RateStatusComponent,
		TooltipComponent,
	],
	templateUrl: './workflow-form-pol-panel.component.html',
})
export class WorkflowFormPolPanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.POL;

	public readonly DEMAND_LEVEL = DEMAND_LEVEL;
	public readonly POL_TEST = POL_TEST;
	public readonly POL_TYPE = POL_TYPE;
	public readonly CONFIDENCE_THRESHOLD = CONFIDENCE_THRESHOLD;

	public get mode(): string {
		return String(this.group.get('mode')?.value ?? '');
	}

	public get demandType(): string {
		return this.readSelectId('type');
	}

	public get scoringThreshold(): string {
		return this.readSelectId('setting.scoring');
	}

	public get demandLevelsPol(): IPolDemandLevel[] {
		return this.host.demandLevelsPol;
	}

	public get autoModeGif(): string {
		return `images/pol-mode-auto${this.mode === 'auto' ? '-active' : ''}.gif`;
	}

	public setMode(next: 'auto' | 'manual', selected: boolean): void {
		this.patchControl('mode', selected ? next : '');
	}

	public hasAvailableTest(test: POL_TEST): boolean {
		const tests = this.group.get('setting.available_tests')?.value as POL_TEST[] | undefined;
		return Boolean(tests?.includes(test));
	}

	public get availableTestsUnderQuota(): boolean {
		const tests = this.group.get('setting.available_tests')?.value as unknown[] | undefined;
		const totalTest = Number(this.group.get('setting.total_test')?.value ?? 0);
		return (tests?.length ?? 0) < totalTest + 1;
	}

	public changeAvailableTests(status: boolean, test: POL_TEST): void {
		this.host.changeAvailableTests(status, test);
	}
}
